/*!
 * viewBand.js — the part of the score area nothing covers
 * © 2026 Rob Canning — GPLv3
 *
 * The score is drawn at full window height, under the pinned top bar and the
 * transport. Anything that fits something "on screen" -- fit my part
 * (layerFilter.js), a map station (route.js) -- fits it into the band
 * between them, or its top and bottom end up under the bars.
 */

/**
 * Top and bottom of the uncovered band, px from the container's top.
 * @param {DOMRect} cr  the score container's rect
 * @returns {[number, number]}
 */
export function visibleBand(cr) {
  const shown = (el) => {
    if (!el) return null;
    const cs = getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || Number(cs.opacity) < 0.1) return null;
    const r = el.getBoundingClientRect();
    return r.height > 0 ? r : null;
  };
  const top = shown(document.getElementById("top-bar"));
  const bottom = shown(document.getElementById("controls"));
  let b0 = top && top.bottom > cr.top ? top.bottom - cr.top : 0;
  let b1 = bottom && bottom.top < cr.bottom ? bottom.top - cr.top : cr.height;
  if (!(b1 - b0 > cr.height * 0.3)) { b0 = 0; b1 = cr.height; }   // bars in the way of everything: ignore them
  return [b0, b1];
}

/**
 * The stage's uncovered band, in px of the window: { left, top, width,
 * height } -- where a console line's at: and size: are fractions of.
 */
export function stageBand() {
  const cr = (document.getElementById("scoreContainer") || document.documentElement).getBoundingClientRect();
  const [b0, b1] = visibleBand(cr);
  return { left: cr.left, top: cr.top + b0, width: cr.width, height: b1 - b0 };
}

/** at:0.5 -- the same across and down: [0.5, 0.5]. A pair, or anything else, as it is. */
export function atPair(at) {
  if (at == null || Array.isArray(at) || typeof at === "object" || String(at).trim() === "") return at;
  const n = Number(at);
  return Number.isFinite(n) ? [n, n] : at;
}
